import React from 'react';

const ProgramInfoSection = () => {
  return (
    <section className="relative">
      {/* Eligibility Section */}
      <section className="eligibility" id="eligibility">
        <h2 className="section-title">Ești eligibil?</h2>
        
        <div className="eligibility-list">
          <div className="eligibility-item">
            <div className="eligibility-icon">🎂</div>
            <h3 className="eligibility-title">Ai între 18 și 29 de ani</h3>
            <p className="eligibility-text">Sesiunea din octombrie 2026 este dedicată exclusiv tinerilor care nu au împlinit 30 de ani la înscriere.</p>
          </div>
          
          <div className="eligibility-item">
            <div className="eligibility-icon">🎒</div>
            <h3 className="eligibility-title">Ai terminat cel puțin gimnaziul</h3>
            <p className="eligibility-text">Condiția minimă de școlarizare este absolvirea învățământului gimnazial (ISCED 2).</p>
          </div>
          
          <div className="eligibility-item">
            <div className="eligibility-icon">🗺️</div>
            <h3 className="eligibility-title">Din toată țara</h3>
            <p className="eligibility-text">Sunt locuri separate pentru București-Ilfov și pentru regiunile mai puțin dezvoltate. Contează domiciliul tău.</p>
          </div>
          
          <div className="eligibility-item">
            <div className="eligibility-icon">✈️</div>
            <h3 className="eligibility-title">Inclusiv dacă te-ai întors în țară</h3>
            <p className="eligibility-text">Programul se adresează tinerilor indiferent de statutul pe piața muncii: angajați, studenți, fără loc de muncă sau reveniți din străinătate.</p>
          </div>
          
          <div className="eligibility-item">
            <div className="eligibility-icon">🔁</div>
            <h3 className="eligibility-title">Ai ratat cursul în 2025?</h3>
            <p className="eligibility-text">Dacă ai fost declarat eligibil în prima sesiune dar nu ai absolvit, te poți reînscrie actualizând cererea inițială, cu același email.</p>
          </div>
          
          <div className="eligibility-item">
            <div className="eligibility-icon">⚠️</div>
            <h3 className="eligibility-title">Peste 30 de ani?</h3>
            <p className="eligibility-text">În această sesiune nu mai există locuri pentru persoanele de peste 30 de ani, șomeri sau persoane inactive (Pilonul II).</p>
          </div>
        </div>
      </section>
      
      {/* Steps Section */}
      <section className="steps" id="steps">
        <h2 className="section-title">Pașii spre finanțare</h2>
        
        <div className="steps-container">
          <div className="step-card">
            <div className="step-number">1</div>
            <div className="step-icon">✅</div>
            <h3 className="step-title">Rezervă-ți locul aici</h3>
            <p className="step-text">Completezi formularul în 2 minute. Te contactăm și verificăm împreună dacă ești eligibil.</p>
          </div>
          
          <div className="step-card">
            <div className="step-number">2</div>
            <div className="step-icon">📝</div>
            <h3 className="step-title">Te înscrii pe minimis.imm.gov.ro</h3>
            <p className="step-text">Te ajutăm cu contul și cu alegerea furnizorului de curs. Locurile se ocupă în ordinea înscrierii.</p>
          </div>
          
          <div className="step-card">
            <div className="step-number">3</div>
            <div className="step-icon">💻</div>
            <h3 className="step-title">Urmezi cursul de 40 de ore</h3>
            <p className="step-text">Curs gratuit, cu certificat de absolvire acreditat de Ministerul Muncii. Certificatul este obligatoriu pentru etapa de finanțare.</p>
          </div>
          
          <div className="step-card">
            <div className="step-number">4</div>
            <div className="step-icon">📊</div>
            <h3 className="step-title">Firmă + plan de afaceri</h3>
            <p className="step-text">Îți înființezi firma la ONRC și aplici la grantul de până la 250.000 lei (maximum 90% din cheltuieli, minimum 10% contribuție proprie). Te ajutăm cu planul de afaceri.</p>
          </div>
        </div>
      </section>
      
      {/* Benefits Section */}
      <section className="benefits" id="benefits">
        <h2 className="section-title">Beneficii exclusive</h2>
        
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">🎓</div>
            <h3 className="benefit-title">Curs acreditat de antreprenoriat</h3>
            <p className="benefit-text">Participi la un curs complet de antreprenoriat, de 40 de ore, cu certificat acreditat de Ministerul Muncii, condiție obligatorie pentru a accesa finanțarea.</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">📋</div>
            <h3 className="benefit-title">Zero birocrație</h3>
            <p className="benefit-text">Te ghidăm la înscrierea pe platformă, la înființarea firmei și la pregătirea dosarului de finanțare.</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">👨‍💼</div>
            <h3 className="benefit-title">Consultanță personalizată</h3>
            <p className="benefit-text">Experții noștri te ghidează în fiecare etapă a proiectului, oferindu-ți sfaturi personalizate pentru afacerea ta.</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">💰</div>
            <h3 className="benefit-title">Finanțare nerambursabilă</h3>
            <p className="benefit-text">După curs, firma ta poate aplica la un grant de până la 250.000 lei, în sesiunea separată pentru persoane juridice.</p>
          </div>
        </div>
      </section>
      
      {/* Countdown Section */}
      <section className="countdown" id="countdown">
        <h2 className="countdown-title">ATENȚIE! 17.600 de locuri la nivel național, alocate în ordinea înscrierii. În 2025, unele categorii s-au ocupat în primele ore.</h2>
      </section>
      
      
    </section>
  );
};

export default ProgramInfoSection;